export default __webpack_public_path__ + "static/media/flow_1.467d7104.jpg";